// extracted by mini-css-extract-plugin
var _1 = "CgV8D elide";
var _2 = "J2TBx";
var _3 = "yZibo";
var _4 = "Na7hN";
var _5 = "p4uob";
var _6 = "n295R elide";
var _7 = "KKnIZ";
var _8 = "yFzOe elide";
export { _1 as "category", _2 as "close", _3 as "description", _4 as "footer", _5 as "glossary", _6 as "glossaryLink", _7 as "header", _8 as "name" }
